<p class="textS+" style="height: 80%; margin: 0">
  {{this.localiser.get("fade.infoGroups.sentence1")}}<br>
  {{this.localiser.get("fade.infoGroups.sentence2")}}<br>
  {{this.localiser.get("fade.infoGroups.sentence3")}}
</p>
<div style="text-align: center; height: 20%">
  <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("fade.buttonClose")}}</button>
</div>
